<div class="deal-window-container">
  <div class="deal-toolbar space-between" [ngStyle]="{'background-color':theme.subheader_bg, 'color':theme.subheader_fg}">
    <span style="display: flex; align-items: center; gap: 15px;">
      <button mat-icon-button (click)="goBack()" title="List Deals">
        <mat-icon>list</mat-icon>
      </button>
      <button style="background-color: orange;" mat-mini-fab [matMenuTriggerFor]="alerts"
              *ngIf="!!selectedDeal.dealAlerts.length">
        <mat-icon style="color: white;" [matBadge]="selectedDeal.dealAlerts.length" matBadgeColor="warn">warning
        </mat-icon>
      </button>
      <button style="background-color: green; cursor: default;" mat-mini-fab
              *ngIf="!!selectedDeal.dealAlerts && selectedDeal.dealAlerts.length == 0">
        <mat-icon style="color: white; height: 40px; width: 40px;">verified</mat-icon>
      </button>
      <!-- <mat-spinner *ngIf="loading" [diameter]="36" color="accent"></mat-spinner> -->

      <!-- ALERT MENU START-->
      <mat-menu #alerts="matMenu" id="alerts">
        <ul id="alert-item-list">
          <li *ngFor="let t of selectedDeal.dealAlerts">
            <div class="task-item"
                  [ngStyle]="{'background-color':getTaskBg(t)}">
              <div class="text-center task-icon">
                <mat-icon>{{getTaskImage(t.status)}}</mat-icon>
              </div>
              <div>
                <span style="font-size:medium; font-weight: bold;">{{t?.title}}</span><br/>
                <span style="font-size:small;">{{t?.message}}</span><br/>
                <span style="font-size:small; font-weight: lighter; cursor: pointer; color: #0033ff;"
                      (click)="goToTask(t)"><u>{{t?.linkText}}</u></span>
              </div>
            </div>
          </li>
        </ul>
      </mat-menu>
      <!--ALERT MENU END-->
      <span>{{ selectedDeal.projectName || 'Viewing Deal' }}</span>
    </span>


    <span style="display: flex; align-items: center; gap: 2px;">

      <button mat-button color="primary" 
        *ngIf="util.isAdmin() && selectedDeal.dealWorkflow == 'LIVE' && !dealPreviewUrl" (click)="revealDealPreviewUrl()">
        Click to copy deal preview link to clipboard
      </button>
      <em *ngIf="dealPreviewUrl">{{ dealPreviewUrl }}</em>

      <!-- <div *ngIf="allowApproval()" style="display: flex; align-items: center; gap: 15px;">
        <button  mat-raised-button color="primary"
                (click)="approveDeal(selectedDeal)">
                ADMIN Approve Deal
        </button>
        <button mat-raised-button color="warn"
                (click)="declineDeal(selectedDeal)">
                ADMIN Decline Deal
        </button>
      </div> -->

      <!--      issuer actions-->
      <div *ngIf="util.isIssuer()" style="display: flex; align-items: center; gap: 15px;">
        <button mat-raised-button color="primary" 
          *ngIf="selectedDeal.isPreNda" 
          (click)="investorSignNda(selectedDeal)">
          Sign NDA
        </button>
      </div>

      <!--      investor actions-->
      <div *ngIf="util.isInvestor()" style="display: flex; align-items: center; gap: 15px;">
        <button mat-raised-button color="warn"
                (click)="investorDecline(selectedDeal)"
                [hasPermission]="util.Permission.CAN_ACCESS_DEAL_DECLINE"
                [disabledOption1]="{ condition: selectedDeal.investorDealWorkflow == 'DECLINED', message: 'Deal already declined!' }"
        >
        Decline Deal
        </button>
        <button mat-raised-button color="primary"
                *ngIf="selectedDeal.isPreNda && selectedDeal.investorDealWorkflow != 'DECLINED'"
                (click)="investorSignNda(selectedDeal)"
        >
        Sign NDA
        </button>
        <button mat-raised-button color="primary"
                *ngIf="!selectedDeal.isPreNda && selectedDeal.dealCloseType.toUpperCase() === 'DRAWDOWN'"
                (click)="investorIndicateInterest(selectedDeal)"
                [hasPermission]="util.Permission.CAN_ADD_DEAL_SYNDICATION"
                >
        Indicate Interest
        </button>
        <button mat-raised-button color="primary"
                *ngIf="!selectedDeal.isPreNda && selectedDeal.dealCloseType.toUpperCase() === 'EVERGREEN'"
                (click)="investorSubscribe(selectedDeal)"
                [hasPermission]="util.Permission.CAN_ADD_DEAL_SYNDICATION"
        >
        Subscribe
        </button>
      </div>
    </span>
  </div>
  <div class="deal-navbar">
    <nav id="deal-nav" dense
        mat-tab-nav-bar
        style="width: 100%"
        [ngStyle]="{'background-color': theme.subheader_bg}"
    >
      <a mat-tab-link *ngFor="let link of links"
        [routerLink]="link.link"
        routerLinkActive="active-link"
        [active]="activeLink.link == link.link"
        [disabled]="!link.enabled"
        [hidden]="link.hidden"
        [title]="link.toolTip"
      >
        {{ link.title }}
      </a>



    <!-- <div *ngFor="let link of links">
      <a *ngIf="link.enabled"
          mat-tab-link
          (click)="activeLink = link; navigate(link)"
          [active]="activeLink.link == link.link"
          [disabled]="!link.enabled"
          [hidden]="link.hidden"
          [ngStyle]="{'background-color':theme.subheader_bg, 'color':theme.subheader_fg}"
      ><span>{{ link.title }}</span></a>
      <span class="fake-tab" *ngIf="!link.enabled" [matTooltip]="link.toolTip" [hidden]="link.hidden"
            matTooltipPosition="below">{{ link.title }}</span>
      </div> -->
    </nav>
  </div>
  <div class="deal-content-container">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="notes-tongue" (click)="notesService.launchNotes()">
  <mat-icon role="img" title="Deal Notes">description</mat-icon>
</div>